module.exports = __webpack_public_path__ + "static/media/wifi-level-2.35a0313a.svg";